import React from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";

const ConfirmRemovePopup = ({
    title = "Remove",
    message,
    confirmLabel = "Remove",
    isRemoving = false,
    error = null,
    onCancel,
    onConfirm,
}) => {
    return (
        <div
            className="watchlists-note-popup-overlay"
            onClick={(e) => {
                if (e.target === e.currentTarget && !isRemoving)
                    onCancel?.();
            }}
        >
            <div className="add-task-popup watchlists-confirm-remove-popup">
                <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
                    <div style={{ width: "50%" }}>
                        <h3 style={{ margin: 0 }}>{title}</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            type="button"
                            className="close-button"
                            onClick={onCancel}
                            disabled={isRemoving}
                            aria-label="Close"
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div style={{ textAlign: "center", padding: "24px 8px 8px" }}>
                    {message}
                </div>

                {error && <div style={{ color: "#e53e3e", textAlign: "center", marginTop: "8px" }}>{error}</div>}

                <div className="action-button-bar">
                    <div className="action-button-bar-left">
                        <button
                            type="button"
                            className="action-button cancel-button"
                            onClick={onCancel}
                            disabled={isRemoving}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className="action-button-bar-center"></div>
                    <div className="action-button-bar-right">
                        {isRemoving ? (
                            <LoadingSpinnerImage />
                        ) : (
                            <button
                                type="button"
                                className="action-button delete-button"
                                onClick={onConfirm}
                            >
                                {confirmLabel}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmRemovePopup;
